module.exports = __webpack_public_path__ + "img/linkedin.808bfc78.svg";